import React from "react";
import { useHistory } from "react-router-dom";
import "./style.css";

const NewBackButton = () => {
  const history = useHistory();

  const handleBack = () => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push("/");
    }
  };

  return (
    <div className="new-back-button">
      <button onClick={handleBack} className="new-back-button__btn">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
        Înapoi
      </button>
    </div>
  );
};

export default NewBackButton;
